import { useSelector } from 'react-redux'
import { PrivateSpace } from '@weblite/ts-action/private-space'
import { privateSpaceView } from './storage'

export function usePrivateSpace(): PrivateSpace {
  return useSelector(privateSpaceView)
}
